import I18n from 'lib/i18n/i18n';
import echarts from 'echarts';

export default function getOption(props){
    let subsetName = props.subsetName.charAt(0).toUpperCase() + props.subsetName.slice(1);
    const subsetDarkColor = I18n.getString(`itemPage::trends::priceOverTime::colors::dark${subsetName}`);
    const subsetLightColor = I18n.getString(`itemPage::trends::priceOverTime::colors::light${subsetName}`);
    const todayIndex = 2;
    let price = props.subsetValue;//props.data[todayIndex];
    let priceText =  Math.round(price).toLocaleString('en');
    // let max = Math.max(...props.data);
    const chartHeight = 140;
    // let graphHeight = (max/props.height) * chartHeight;
    // const minHeight = 20;

    if(subsetName == 'CenterStone'){
        priceText = `${Math.round(props.estRange.low - props.sumNowSubsets).toLocaleString('en')} - \$${Math.round(props.estRange.high - props.sumNowSubsets).toLocaleString('en')}`
    }

    // calculate label dashed line height.
    // if label will be too high, it will be out of max Yaxis bound, and will become outside visibility.
    // lets move it down in this case.
    let label_line_height = props.height * 0.2; // line height is 20% of full grapph height (measured in Yaxis points) (USD in our case)
    let label_height = 1600; // measured in Yaxis points (USD in our case)

    let label_line_y1 = price;
    let label_line_y2 = ((price + label_height + label_line_height) < props.height) ? (price + label_line_height) : (price - label_line_height);

    let option = {
        grid:{
            height: chartHeight,
            top: 'bottom',
            left: '5%',
            right: 0
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            axisTick:   { show: false },
            axisLabel:  { show: false },
            axisLine:   { show: false },
            splitLine:  { show: false }
        },
        yAxis: {
            type: 'value',
            max: props.height,
            axisTick:   { show: false },
            axisLabel:  { show: false },
            axisLine:   { show: false },
            splitLine:  { show: false }
        },
        series: [{
            type: 'line',
            data: props.data,
            areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 1.2, 0, [{
                    offset: 0,
                    color: subsetDarkColor
                }, {
                    offset: 1,
                    color: subsetLightColor
                }])
            },
            color: subsetDarkColor,
            lineStyle:{
                width: 0
            },
            symbol: 'none',
            markLine: {
                lineStyle: {
                    color: I18n.getString('itemPage::trends::priceOverTime::colors::lineStyle'),
                    width: 1,
                    type: 'dashed',
                    emphasis: {
                        width: 1,
                        type: 'dashed',
                    }
                },
                label: {
                    normal: {
                        position: 'end',
                        show: true,
                        formatter: `$${priceText}`,
                        backgroundColor: 'white',
                        padding: [12,20],
                        lineHeight: 5,
                        align: 'center',
                        width: '75px',
                        height: '30px',
                        distance: 20,
                        shadowBlur: 6,
                        shadowOffsetX: 1,
                        shadowOffsetY: 1,
                        shadowColor: 'rgba(136, 135, 135, 0.5)',
                        fontSize: 16,
                        color:'#000000',
                        fontWeight: 'bold'
                    }
                },
                data: [[
                    { coord: [todayIndex, label_line_y1] },
                    { coord: [todayIndex, label_line_y2], symbol: 'none' }
                ]]
            }
        }]
    };
    return option;
}
